<template>
  <section class="relative px-5 py-3">
    <h2 class="text-3xl font-headline mt-5 mb-2">
      {{ researchCompass.title }}
    </h2>
    <research-compass-question
      v-for="question in researchCompass.questions"
      :key="question.hashedId"
      :question="question"
      :modes="modes"
    />
  </section>
</template>
<script>
import ResearchCompassQuestion from "./ResearchCompassQuestion.vue";

export default {
  components: {
    ResearchCompassQuestion,
  },
  props: {
    hashedId: String,
    researchCompass: Object,
  },
  data() {
    return {};
  },
  computed: {
    modes() {
      const modes = ["sources", "experts"];
      if (
        this.researchCompass.collaborationSpace?.isResearchCompassPatentEnabled
      ) {
        modes.push("patents");
      }
      if (
        this.researchCompass.collaborationSpace
          ?.isResearchCompassIndustryPartnersEnabled
      ) {
        modes.push("industryPartners");
      }
      return modes;
    },
  },
  methods: {},
};
</script>
